export default __webpack_public_path__ + "static/control-plane-c-411b075805428ad31abc84c4d4bda0c8.webp";